import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { Storage } from "@ionic/storage";
import { ServiceProvider } from "./../../providers/service/service";
import { Http, RequestOptions, Headers } from "@angular/http";
import { TranslateService } from "@ngx-translate/core";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController, LoadingController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-merchant-overview-movement",
  templateUrl: "merchant-overview-movement.html",
})
export class MerchantOverviewMovementPage {
  items: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLMerchantLatestMovement;

      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.items = data;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  doRefresh(refresher) {
    this.storage.get("token").then((token) => {
      var link = this.services.URLMerchantLatestMovement;

      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.items = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
    refresher.complete();
  }

  backPage() {
    this.navCtrl.pop();
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-overview-movement/merchant-overview-movement.ts